export default "__VITE_ASSET__BrEKJdJC__"